import { createSlice } from "@reduxjs/toolkit";

const batchInmateMovementSlice = createSlice({
  name: "batchInmateMovement",
  initialState: {
    movementRecords: null,
    searchType: null,
  },
  reducers: {
    setMovementRecords: (state, action) => {
      state.movementRecords = action.payload;
    },
    setSearchType: (state, action) => {
      state.searchType = action.payload;
    },
  },
});

export const { setMovementRecords, setSearchType } =
  batchInmateMovementSlice.actions;
export default batchInmateMovementSlice.reducer;
